import React from "react";

interface NewsletterContext {
  height: number;
  setHeight: (height: number) => void;
}

const NewsletterContext = React.createContext<NewsletterContext>({
  height: 353.78,
  setHeight: () => {},
});

const NewsletterContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [height, setHeight] = React.useState(353.78);

  return (
    <NewsletterContext.Provider value={{ height, setHeight }}>
      {children}
    </NewsletterContext.Provider>
  );
};

const useNewsletterContext = () => {
  const context = React.useContext(NewsletterContext);
  if (!context) {
    throw new Error(
      "useNewsletterContext must be used within a NewsletterContextProvider"
    );
  }
  return context;
};

export { NewsletterContextProvider, useNewsletterContext };
